import { useEffect, useState } from "react";
import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import { useHandleUserAction } from "@features/mySph/hooks/useHandleUserAction";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import useUserInfoStore, {
  UserStore,
} from "@features/mySph/store/useUserInfoStore";
import { DEFAULT_USER_INFO } from "@features/mySph/utils/constants";
import { usePostHog } from "@features/posthog/hooks/usePosthogProvider";
import useIsAppWebView from "@hooks/useIsAppWebView";
import { ESHOP_DOMAIN } from "@routes/MyAccount/utils/constants";
import { getEnvironment } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";

export default function MyAccountPageSetting(): React.ReactElement {
  const isAppWebView = useIsAppWebView();

  const { loginId } = useUserInfo();
  const { setUserInfo, setIsAuthenticated } = useUserInfoStore(
    (state: UserStore) => ({
      setUserInfo: state.setUserInfo,
      setIsAuthenticated: state.setIsAuthenticated,
    })
  );

  const { handleUserLogout, handleUpdatePassword } = useHandleUserAction();
  const posthog = usePostHog();

  const [manageAccountLink, setManageAccountLink] = useState<string>("");

  const handleLogout = () => {
    posthog?.reset(true);

    setUserInfo(DEFAULT_USER_INFO);
    setIsAuthenticated(false);

    const domain = getEnvironmentDomain(getEnvironment());
    handleUserLogout(domain);
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    const url = `${ESHOP_DOMAIN}your-account/?utm_campaign=manageaccount&utm_medium=sph-publication&utm_source=bt&utm_content=manageaccountlink-dropdown&pub-code=bt${encodeURIComponent(
      location.href
    )}`;
    setManageAccountLink(url);
  }, []);

  return (
    <div data-testid="my-account-setting-component">
      <div className="cursor-pointer py-2 font-poppins text-2xs font-semibold leading-loose tracking-2% text-gray-850 underline-offset-2 hover:underline">
        <a target="_blank" href={manageAccountLink} rel="noreferrer">
          Manage Account
        </a>
      </div>

      <button
        className="cursor-pointer py-2 font-poppins text-2xs font-semibold leading-loose tracking-2% text-gray-850 underline-offset-2 hover:underline"
        onClick={handleUpdatePassword}
      >
        Update your password
      </button>

      <Link
        to={RouteFactory.help}
        reloadDocument
        className="block cursor-pointer py-2 font-poppins text-2xs font-semibold leading-loose tracking-2% text-gray-850 underline-offset-2 hover:underline"
      >
        Help
      </Link>

      <a
        className="block cursor-pointer py-2 font-poppins text-2xs font-semibold leading-loose tracking-2% text-gray-850 underline-offset-2 hover:underline"
        href="https://subscribe.sph.com.sg/contact-us-mobile/"
      >
        Contact Us
      </a>

      <>
        {!isAppWebView ? (
          <button
            className="block cursor-pointer py-2 font-poppins text-2xs font-semibold leading-loose tracking-2% text-gray-850 underline-offset-2 hover:underline"
            onClick={handleLogout}
          >
            Log out
          </button>
        ) : null}
      </>

      <span id="sph_user_name" className="hidden">
        {encodeURI(loginId || "")}
      </span>
    </div>
  );
}
